/***
 * !!!!!! HEADS UP !!!!!!
 *
 * THIS FILE IS USED IN A CONSTRAINED ENVIRONMENT
 * SEE src/constrained/README.md FOR MORE INFORMATION
 *
 * Outlook for Windows runs the compose functions in a limited javascript environment,
 * please try to limit the items being imported here to the absolute minimum as it is
 * very hard to determine if things go wrong and how.
 *
 * If using some of the common abstractions, check their imports and extract to a
 * common function if necessary.
 */

/** Converts an @see Office.Error object into a real error object. */
export class OfficeError extends Error {
  cause: Error | null = null;
  constructor(
    { message, code, name }: { message: string; code: number; name: string },
    cause: Error | null = null,
  ) {
    super(message);
    this.name = `OfficeError [${name}] (${code})`;
    this.cause = cause;
  }
}

/**
 * Try to get an OfficeError from an unknown error
 */
export function getOfficeErrorFromError(error: unknown): OfficeError {
  if (error instanceof OfficeError) {
    return error;
  }
  if (error instanceof Error) {
    return new OfficeError({ message: error.message, name: error.name, code: 0 }, error);
  }
  if (typeof error === 'string') {
    return new OfficeError({ message: error, name: 'unknown', code: 0 });
  }
  return new OfficeError({ message: 'Unknown error', name: 'unknown', code: 0 }, error as any);
}
